<div class="study-viewer-controls">
  <app-dashboard-study-viewer-controls-select
    viewName="View"
    [choicesControl]="viewerModeControl"
    [choices]="viewerModeChoices"
  >
    <img
      class="dashboard-study-viewer-controls-select__icon"
      ngSrc="/assets/images/icons/view-type.svg"
      width="24"
      height="24"
      alt="View Type Icon"
    >
  </app-dashboard-study-viewer-controls-select>

  <app-dashboard-study-viewer-controls-select
    viewName="Scan Type"
    [choicesControl]="scanTypeControl"
    [choices]="scanTypeChoices()"
  >
    <img
      class="dashboard-study-viewer-controls-select__icon"
      ngSrc="/assets/images/icons/view-type.svg"
      width="24"
      height="24"
      alt="View Type Icon"
    >
  </app-dashboard-study-viewer-controls-select>

  @if (renderedViewRegion()?.body_segment === viewRegionBodySegments.Brain) {
    <app-dashboard-study-viewer-controls-head-outline></app-dashboard-study-viewer-controls-head-outline>
  } @else {
    <div
      class="controls-button"
      (click)="resetCurrentView()"
    >
      <div class="controls-button__icon">
        <img
          class="controls-button__icon-image"
          ngSrc="/assets/images/icons/view-type.svg"
          width="24"
          height="24"
          alt="Reset View Icon"
        >
      </div>

      <div class="controls-button__label">Reset View</div>
    </div>
  }

  @if (studyViewerMode() === studyViewerModes.Scan) {
    @let isMagnifierReady = currentLoadingStatus() === studyViewerLoadingStates.viewerRendered;
    <div
      class="controls-button"
      [ngClass]="{
        'controls-button__in-progress': !isMagnifierReady
      }"
      (click)="enterZoomedView(isMagnifierReady)"
    >
      <div class="controls-button__icon">
        <img
          class="controls-button__icon-image"
          ngSrc="/assets/images/icons/view-type.svg"
          width="24"
          height="24"
          alt="Magnifier Icon"
        >
      </div>

      <div class="controls-button__label">Magnifier</div>
    </div>
  }
</div>
